import React, { useContext } from "react";
import { Footer, PageNumber, ImageRun, Header, Document, Packer, Paragraph, TextRun, AlignmentType, BorderStyle, Table, TableRow, TableCell, WidthType, } from "docx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import logoRockai from "./logo.png";
import { Button, Tooltip } from "@blueprintjs/core";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../utils/context/auth.context.ts";
import { AppContext } from "../../utils/context/app.context.js";
import cotizacionesService from "../../services/cotizaciones.service";
import { useLocation } from "react-router";
import { ToWords } from 'to-words';

const toWords = new ToWords({
  localeCode: 'es-ES',

});

//creacion de los estilos 
const textTitulo1 = (contenido) =>
  new TextRun({ text: contenido, bold: true, size: 30, color: "cd8b18", font: "Acumin Variable Concept" });

const textTitulo2 = (contenido) =>
  new TextRun({ text: contenido, bold: true, size: 28, color: "5e4239", font: "Acumin Variable Concept" });

const parrafo = (contenido) =>
  new TextRun({ text: contenido, size: 24, font: "Acumin Variable Concept" });

const parrafoHeader = (contenido) =>
  new TextRun({ text: contenido, size: 16, font: "Acumin Variable Concept" });

const parrafoNegrilla = (contenido) =>
  new TextRun({ text: contenido, bold: true, size: 24, font: "Acumin Variable Concept" });

const COT_DOC = (props) => {
  const { id } = props
  const authContext = useContext(AuthContext)
  const appContext = useContext(AppContext)
  const location = useLocation()
  const { t } = useTranslation();

  async function get(id) {
    if (authContext.verify(location, "GET")) {
      await cotizacionesService.get(id)
        .then(res => {
          generarCotizacion(res.data)
        })
        .catch(error => appContext.errorHandler(error, toast, t))
        .finally(() => {

        })
    } else {
      toast.warning(t('auth.nopermit'))
    }

  }

  function calculate_montos(item) {
    let sum = item.services ? item.services.reduce((cum, next) => cum + (next.monto * next.cantidad), 0) : 0;
    let adm = (sum * Number(item.adm) / 100);
    let imp = (sum * Number(item.imp) / 100);
    let uti = (sum * Number(item.uti) / 100);
    let sub = appContext.cotMontoBase(item);
    let iva = appContext.cotMontoIva(item, false);
    let total = appContext.cotMontoTotal(item, false);

    return {
      sum,
      adm,
      imp,
      uti,
      sub,
      iva,
      total,
    }
  }

  //Constante que carga la imagen
  const cargarImagen = async () => {
    const response = await fetch(logoRockai);
    const blob = await response.blob();
    return await blob.arrayBuffer();
  };

  // funcion para crear la tabla
  const crearTablaPropuestaValores = (item) => {
    let items = item.services || [];

    const encabezado = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(t("cotizacion.document.table_h_1"))] })] }),
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(t("cotizacion.document.table_h_2"))] })] }),
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(t("cotizacion.document.table_h_3"))] })] }),
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(t("cotizacion.document.table_h_4"))] })] }),
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(t("cotizacion.document.table_h_5"))] })] }),
          ],
      });

    const filas = items.map
      ((item) => new TableRow
        ({
          children:
            [
              new TableCell({ children: [new Paragraph({ children: [parrafo((`${item.nombre}`))] })] }),
              new TableCell({ children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [parrafo((t(`general.servicios_medidas.${item.medida}`)))] })] }),
              new TableCell({ children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [parrafo((`${item.cantidad}`))] })] }),
              new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafo(`${appContext.formatCurrency(item.monto)}`)] })] }),
              new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafo(`${appContext.formatCurrency(item.monto * item.cantidad)}`)] })] }),
            ],
        })
      );

    const montos = calculate_montos(item);

    const sum = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafo(t("cotizacion.document.monto_sum"))] })] }),
            new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafoNegrilla(appContext.formatCurrency(montos.sum))] })] }),
          ],
      });

    let rows = [encabezado, ...filas];
    return new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows
    });
  };

  const crearTablaPropuestaTotales = (item, montos) => {

    const adm = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafo(t("cotizacion.document.monto_adm"))] })], columnSpan: 3 }),
            new TableCell({ children: [new Paragraph({ children: [parrafo(`${item.adm}%`)], alignment: AlignmentType.RIGHT, })], columnSpan: 1, }),
            new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafoNegrilla(appContext.formatCurrency(montos.adm))] })], columnSpan: 1, }),
          ],
      });
    const imp = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafo(t("cotizacion.document.monto_imp"))] })], columnSpan: 3, }),
            new TableCell({ children: [new Paragraph({ children: [parrafo(`${item.imp}%`)], alignment: AlignmentType.RIGHT, })], columnSpan: 1, }),
            new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafoNegrilla(appContext.formatCurrency(montos.imp))] })], columnSpan: 1, }),
          ],
      });
    const uti = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafo(t("cotizacion.document.monto_uti"))] })], columnSpan: 3, }),
            new TableCell({ children: [new Paragraph({ children: [parrafo(`${item.uti}%`)], alignment: AlignmentType.RIGHT, })], columnSpan: 1, }),
            new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafoNegrilla(appContext.formatCurrency(montos.uti))] })], columnSpan: 1, }),
          ],
      });
    const sub = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(t("cotizacion.document.monto_sub"))] })], columnSpan: 4, }),
            new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafoNegrilla((montos.sub))] })], columnSpan: 1, }),
          ],
      });
    const iva = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafo(t("cotizacion.document.monto_iva"))] })], columnSpan: 3, }),
            new TableCell({ children: [new Paragraph({ children: [parrafo(`${item.iva}%`)], alignment: AlignmentType.RIGHT, })], columnSpan: 1, }),
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(appContext.formatCurrency(montos.iva))], alignment: AlignmentType.RIGHT, })], columnSpan: 1, }),
          ],
      });
    const total = new TableRow
      ({
        children:
          [
            new TableCell({ children: [new Paragraph({ children: [parrafoNegrilla(t("cotizacion.document.monto_total"))] })], columnSpan: 4, }),
            new TableCell({ children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [parrafoNegrilla(appContext.formatCurrency(montos.total))] })], columnSpan: 1, }),
          ],
      });

    let rows = [];
    if (montos.adm) rows = [...rows, adm];
    if (montos.imp) rows = [...rows, imp];
    if (montos.uti) rows = [...rows, uti];
    rows = [...rows, sub];
    if (montos.iva) rows = [...rows, iva];
    rows = [...rows, total];

    return new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows
    });
  };

  const createList = (item) => {
    if (item) return item.split('\n').map(t => new Paragraph({ children: [parrafo(`${t}`)], }));
    else return [new Paragraph({ text: "" })];
  }

  // Inicia el documento
  const generarCotizacion = async (i) => {
    const logoBuffer = await cargarImagen();
    const fecha = new Date(i.fecha);
    fecha.setDate(fecha.getDate() + 1);
    const formatter = new Intl.DateTimeFormat('es', { dateStyle: 'long' });
    const formattedDate = formatter.format(fecha);
    const montos = calculate_montos(i);
    const doc = new Document({
      sections: [
        {
          headers:
          {
            default: new Header
              ({
                children: [

                  new Paragraph({
                    children: [new ImageRun({
                      data: logoBuffer,
                      transformation: {
                        width: 100,
                        height: 60,
                      },
                      format: "png",
                    }),]
                  }),
                  new Paragraph({ children: [parrafoHeader(t("cotizacion.document.header_1")),], }),
                  new Paragraph({ alignment: AlignmentType.LEFT, children: [parrafoHeader(t("cotizacion.document.header_2")),], }),
                  new Paragraph({
                    border: {
                      top: {
                        color: "cd8b18",           // Color negro
                        space: 0,                  // Espacio entre el texto y la línea
                        style: BorderStyle.INSET,  // Tipo de línea (simple)
                        size: 10,                   // Grosor de la línea
                      },
                    },
                  }),
                ],
              }),
          },
          footers: {
            default: new Footer({
              children: [

                new Paragraph({
                  border: {
                    bottom: {
                      color: "cd8b18",           // Color negro
                      space: 0,                  // Espacio entre el texto y la línea
                      style: BorderStyle.INSET,  // Tipo de línea (simple)
                      size: 10,                   // Grosor de la línea
                    },
                  },
                }),

                new Paragraph({ children: [parrafoHeader(t("cotizacion.document.footer_1"))] }),
                new Paragraph({ children: [parrafoHeader(t("cotizacion.document.footer_2"))] }),


                new Paragraph({
                  alignment: AlignmentType.RIGHT, children: [new TextRun({
                    children: ["Página ", PageNumber.CURRENT],
                    size: 20,
                    font: "Acumin Variable Concept",
                  }),
                  ],
                }),
              ],
            }),
          },
          properties: {},
          children: [

            new Paragraph({ children: [parrafo(t("cotizacion.document.intro_1").replace('%', formattedDate))] }),
            new Paragraph({ children: [parrafo(t("cotizacion.document.intro_2").replace('%', i.nombre))] }),
            new Paragraph({ text: "" }),


            //Titulo principal
            new Paragraph({ alignment: AlignmentType.CENTER, children: [textTitulo1(t("cotizacion.document.title").replace('%', i.codigo))] }),
            new Paragraph({ alignment: AlignmentType.CENTER, children: [textTitulo1(`${i.descripcion}`)] }),
            new Paragraph({ text: "" }),

            //Saludo
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p1"))] }),
            new Paragraph({ children: [parrafo(`${i.intro}`)] }),
            new Paragraph({ text: "" }),

            //Alcance
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p2"))] }),
            ...createList(i.alcance),
            new Paragraph({ text: "" }),

            //Informacion requerida
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p3"))] }),
            ...createList(i.requerimientos),
            new Paragraph({ text: "" }),

            //Entregables
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p4"))] }),
            ...createList(i.entregables),
            new Paragraph({ text: "" }),

            //Propuesta economica
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p5"))] }),
            new Paragraph({ text: "" }),

            //Generacion de la tabla
            crearTablaPropuestaValores(i),
            new Paragraph({ text: "" }),
            crearTablaPropuestaTotales(i, montos),
            new Paragraph({ text: "" }),
            new Paragraph({ text: t("cotizacion.document.proposal")
              .replace("%VAR_1%", appContext.formatCurrency(montos.total))
              .replace("%VAR_2%", toWords.convert(montos.total))
              .toUpperCase() }),
            //
            new Paragraph({ text: "" }),
            new Paragraph({ text: "" }),

            //Tiempo de ejecucion
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p6"))] }),
            ...createList(i.tiempo),
            new Paragraph({ text: "" }),

            //Forma de pago
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p7"))] }),
            ...createList(i.pago),
            new Paragraph({ text: "" }),

            //Validez de la oferta
            new Paragraph({ children: [textTitulo2(t("cotizacion.document.p8"))] }),
            ...createList(i.validez),
            new Paragraph({ text: "" }),
            new Paragraph({ text: "" }),
            new Paragraph({ text: "" }),

            new Paragraph({ children: [parrafo(t("cotizacion.document.p9"))] }),
            new Paragraph({ text: "" }),
            new Paragraph({ text: "" }),
            new Paragraph({ text: "" }),
            new Paragraph({ text: "" }),
            new Paragraph({ children: [parrafo(t("cotizacion.document.end_1"))] }),
            new Paragraph({ children: [parrafo(i.responsable ? `${i.responsable}` : t("cotizacion.document.end_2"))] }),
            new Paragraph({ children: [parrafo(t("cotizacion.document.end_3"))] }),
          ],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `${i.codigo} ${i.descripcion}.docx`);

  };

  return <Tooltip content={t("cotizacion.document.gen")} placement="top">
    <Button icon="document" intent='primary' onClick={() => get(id)} />
  </Tooltip>;
};

export default COT_DOC;